// extracted by mini-css-extract-plugin
export default {"flex-div":"_flex-div_uZ5gdh","align-right":"_align-right_JI3URd"};